import React, { useState, useEffect } from "react";

import { FormattedMessage, useIntl } from "react-intl";
import { useFormContext } from "react-hook-form";

import getLabel from "helpers/getLabel";
import Checkbox from "components/atoms/Checkbox/Checkbox";
import DatePicker from "components/atoms/DatePicker/DatePicker";
import TimeInput from "components/atoms/TimeInput/TimeInput";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import errorToast from "helpers/errorToast";
import { getCompanyUsers } from "api";

const NotificationApprovalDelegate = function () {
  const intl = useIntl();
  const { watch } = useFormContext();
  const [delegateApprovalEmailOptions, setDelegateApprovalEmailOptions] = useState([]);
  const isDelegatesApproverEnabled = watch("delegates.approver.approval_delegate");

  useEffect(() => getDelegateApprovalEmailOptions(), []);

  const getDelegateApprovalEmailOptions = () => {
    getCompanyUsers({
      params: {
        filter_same_location: true,
      },
    })
      .then((res) => {
        if (res.data.users) {
          const formattedArray = res.data.users.sort((a, b) => a.email.localeCompare(b.email));
          setDelegateApprovalEmailOptions(
            formattedArray.map((user) => ({
              label: user.email,
              value: user.email,
            })),
          );
        }
      })
      .catch((err) => {
        errorToast(
          err,
          intl.formatMessage({
            id: "settings.couldNotRetrieveUsers",
            defaultMessage: "Could not retrieve users. Please try again later",
          }),
        );
      });
  };

  return (
    <div className="mt-4">
      <Checkbox
        providerSections
        checkboxLabel={intl.formatMessage({
          id: "settings.notifications.identifyDelegateApprover",
          defaultMessage: "Identify delegate approver",
        })}
        name="delegates.approver.approval_delegate"
        required={false}
      >
        <div className="d-flex flex-column pt-15">
          <div className="d-flex flex-wrap">
            <div className="mr-3 mb-xs-2">
              <div className="mb-2 font-b3">
                <FormattedMessage id="settings.notifications.delegateApproval" defaultMessage="Delegate approver" />
              </div>
              <Dropdown
                useHookForm
                name="delegates.approver.approval_delegate_email"
                placeholder={intl.formatMessage({
                  id: "tracking.selectReason",
                  defaultMessage: "Select a reason",
                })}
                options={[
                  {
                    label: intl.formatMessage({
                      id: "settings.address-book.pleaseSelect",
                      defaultMessage: "Please select",
                    }),
                    value: "",
                  },
                  ...delegateApprovalEmailOptions,
                ]}
                required={isDelegatesApproverEnabled}
              />
            </div>

            <div className="mr-3">
              <div className="mb-2 font-b3">
                <FormattedMessage id="settings.notifications.delegationEndDate" defaultMessage="Delegation end date" />
              </div>
              <DatePicker
                name="delegates.approver.approval_delegate_expiration_date"
                minDate={new Date()}
                required={isDelegatesApproverEnabled}
                eventContext="Settings - Notifications"
              />
            </div>
            <div>
              <div className="mb-2 font-b3">
                <FormattedMessage id="settings.notifications.delegationEndTime" defaultMessage="Delegation end time" />
              </div>

              <TimeInput
                name="delegates.approver.approval_delegate_expiration_time"
                required={isDelegatesApproverEnabled}
                eventContext="Settings - Notifications"
                outputFormat="HH:mm"
              />
            </div>
          </div>
          <div className="text-secondary font-b3 mt-2">
            <FormattedMessage
              id="settings.notifications.identifyDelegateApproverInfo"
              defaultMessage="The delegate approver will receive your approval request, but only for their own {label}"
              values={{
                label: getLabel("Payment location", "capitalize"),
              }}
            />
          </div>
        </div>
      </Checkbox>
    </div>
  );
};

export default NotificationApprovalDelegate;
